import React, {useState, useEffect} from "react";
import {Button, Col, DatePicker, Form, Input, Row, Space, message} from "antd";
import {EditOutlined, CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import moment from "moment";
import locale from "antd/es/date-picker/locale/tr_TR";
const CourierSummaryOssStartDate = ({
    ossStartDate: initialOssStartDate,
    onSave,
    selectedOssStartDate
}) => {
    const {t} = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const stores = useStore();

    useEffect(() => {
        if (selectedOssStartDate !== undefined) {
            form.setFieldsValue({
                ossStartDate: selectedOssStartDate ? moment(selectedOssStartDate) : undefined
            });
        } else {
            form.setFieldsValue({
                ossStartDate: initialOssStartDate ? moment(initialOssStartDate) : undefined
            });
        }
    }, [selectedOssStartDate, initialOssStartDate]);

    const handleEdit = () => {
        form.setFieldsValue({
            ossStartDate: selectedOssStartDate
                ? moment(selectedOssStartDate)
                : initialOssStartDate
                ? moment(initialOssStartDate)
                : undefined
        });
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        form.resetFields();
    };

    const handleSubmit = async values => {
        try {
            setLoading(true);
            await onSave({ossStartDate: values.ossStartDate});
            setIsEditing(false);
        } catch (error) {
            console.error("Error updating OSS start date:", error);
            message.error(
                error.response?.data?.message ||
                    t("ÖSS Başlangıç Tarihi güncellenirken bir hata oluştu")
            );
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = e => {
        form.setFieldsValue({ossStartDate: e.target.value});
    };

    return (
        <Form
            form={form}
            onFinish={handleSubmit}
            initialValues={{
                ossStartDate: selectedOssStartDate
                    ? moment(selectedOssStartDate)
                    : initialOssStartDate
                    ? moment(initialOssStartDate)
                    : undefined
            }}
        >
            <Row gutter={[8, 8]} align="middle">
                <Col flex="auto">
                    {isEditing ? (
                        <Form.Item name="ossStartDate" style={{marginBottom: 0}}>
                            <DatePicker
                                placeholder={"ÖSS Başlangıç Tarihi Giriniz"}
                                format="DD.MM.YYYY"
                                disabledDate={current => {
                                    return (
                                        !current ||
                                        current.isAfter(moment()) ||
                                        current.isBefore(moment("1950-01-01"))
                                    );
                                }}
                                locale={locale}
                            />
                        </Form.Item>
                    ) : (
                        <div style={{padding: "5px 0"}}>
                            {selectedOssStartDate
                                ? moment(selectedOssStartDate).format("DD.MM.YYYY")
                                : initialOssStartDate
                                ? moment(initialOssStartDate).format("DD.MM.YYYY")
                                : t("-")}
                        </div>
                    )}
                </Col>
                <Col>
                    {stores.meStore.checkRole("updateCourierOssStartDate") &&
                        (isEditing ? (
                            <Space>
                                <Button
                                    type="text"
                                    icon={<CheckOutlined />}
                                    htmlType="submit"
                                    loading={loading}
                                />
                                <Button
                                    type="text"
                                    icon={<CloseOutlined />}
                                    onClick={handleCancel}
                                    disabled={loading}
                                />
                            </Space>
                        ) : (
                            <Button type="text" icon={<EditOutlined />} onClick={handleEdit} />
                        ))}
                </Col>
            </Row>
        </Form>
    );
};

export default CourierSummaryOssStartDate;
